import "../styles/services-activities.css";

import activity1 from "../assets/img/services-activities/design24-1.jpg";
import activity2 from "../assets/img/services-activities/design24-10.jpg";
import activity3 from "../assets/img/services-activities/design24-11.jpg";
import activity4 from "../assets/img/services-activities/design24-12.jpg";
import activity5 from "../assets/img/services-activities/design24-13.jpg";
import activity6 from "../assets/img/services-activities/design24-14.jpg";
import activity7 from "../assets/img/services-activities/design24-15.jpg";
import activity8 from "../assets/img/services-activities/design24-16.jpg";
import activity9 from "../assets/img/services-activities/design24-17.jpg";
import activity10 from "../assets/img/services-activities/design24-18.jpg";
import activity11 from "../assets/img/services-activities/design24-19.jpg";
import activity12 from "../assets/img/services-activities/design24-2.jpg";
import activity13 from "../assets/img/services-activities/design24-20.jpg";
import activity14 from "../assets/img/services-activities/design24-21.jpg";
import activity15 from "../assets/img/services-activities/design24-3.jpg";
import activity16 from "../assets/img/services-activities/design24-6.jpg";
import activity17 from "../assets/img/services-activities/design24-8.jpg";
import activity18 from "../assets/img/services-activities/design24-9.jpg";

const activities = [
  { id: 1, src: activity1, alt: "Activity 1" },
  { id: 2, src: activity2, alt: "Activity 2" },
  { id: 3, src: activity3, alt: "Activity 3" },
  { id: 4, src: activity4, alt: "Activity 4" },
  { id: 5, src: activity5, alt: "Activity 5" },
  { id: 6, src: activity6, alt: "Activity 6" },
  { id: 7, src: activity7, alt: "Activity 7" },
  { id: 8, src: activity8, alt: "Activity 8" },
  { id: 9, src: activity9, alt: "Activity 9" },
  { id: 10, src: activity10, alt: "Activity 10" },
  { id: 11, src: activity11, alt: "Activity 11" },
  { id: 12, src: activity12, alt: "Activity 12" },
  { id: 13, src: activity13, alt: "Activity 13" },
  { id: 14, src: activity14, alt: "Activity 14" },
  { id: 15, src: activity15, alt: "Activity 15" },
  { id: 16, src: activity16, alt: "Activity 16" },
  { id: 17, src: activity17, alt: "Activity 17" },
  { id: 18, src: activity18, alt: "Activity 18" },
];

const ServicesActivities = () => {
  return (
    <div className="services-activities-bg">
      <div className="services-activities">
        <div className="services-activities__wrapper">
          <h2 className="services-activities__title">
            {/* Các hoạt động dịch vụ & đào tạo */}
            Các hoạt động dịch vụ & đào tạo
            <span className="line"></span>
          </h2>
        </div>

        <div className="activity-list">
          {activities.map((item) => (
            <div
              key={item.id}
              className="activity-item"
            >
              <div className="activity-content">
                <img
                  src={item.src}
                  alt={item.alt}
                  loading="lazy"
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ServicesActivities;
